import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentColor, onUserImgError } from '../../../../helpers/Helpers';
import { REPLY_MESSAGE } from '../../../../redux/actions/messagesActions';
import DOMPurify from 'dompurify';
import { ReactComponent as CloseIcon } from '../../../../assets/svg/icons/close.svg';
import { messageData } from '../../../../helpers/Dialogs';
import { showAppPromotion } from '../../../../helpers/AppPromotionHelper';
import { Image } from 'antd';

const ReplyMessage = () => {
    const dispatch = useDispatch();

    const { activeMessage } = useSelector((state) => state.replyMessage);
    const isAppPromoted = showAppPromotion();

    const closeActiveMessage = useCallback(() => {
        dispatch({
            type: REPLY_MESSAGE,
            payload: {
                activeMessage: null,
                activePublisher: null,
            },
        });
    }, [dispatch]);

    if (activeMessage) {
        const activePublisher = activeMessage.user;
        const currentUserColor = getCurrentColor(activePublisher, 0);
        const text = messageData(activeMessage);
        let subject = '',
            courses = '';
        /* if (activePublisher && activePublisher.user_tags) {
            subject = activePublisher.user_tags.subject && activePublisher.user_tags.subject[0] ? activePublisher.user_tags.subject[0].name : "";
            courses = activePublisher.user_tags.courses_types && activePublisher.user_tags.courses_types[0] ? activePublisher.user_tags.courses_types[0].name : "";
        }*/
        return (
            <div key={activeMessage.id} className={`msg-item reply-item ${isAppPromoted ? 'promotion' : ''}`}>
                {activePublisher && activePublisher.avatar ? (
                    <div className="msg-avatar-block">
                        <Image
                            className="msg-item-img"
                            src={activePublisher.avatar.sizes['70x70'] || activePublisher.avatar.original}
                            onError={onUserImgError}
                            alt={activePublisher.name ? activePublisher.name.slice(0, 1).toUpperCase() : 'D'}
                        />
                    </div>
                ) : (
                    <div className="msg-avatar-block" style={{ backgroundColor: currentUserColor }}>
                        <span>
                            {activePublisher && activePublisher.name
                                ? activePublisher.name.slice(0, 1).toUpperCase()
                                : 'D'}
                        </span>
                    </div>
                )}
                <div className="msg-block-item">
                    <p className="msg-name">
                        {activePublisher && activePublisher.name ? activePublisher.name : 'Deleted user'}
                        <span>{subject && courses ? ' (' + subject + ' ' + courses + ')' : ''}</span>
                    </p>
                    <p
                        className="msg-text msg-text-short msg-text-short-with-quotes"
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(text, {
                                ALLOWED_TAGS: [' ', 'a', 'b', 'span', 'p', 'br'],
                                ADD_ATTR: ['target'],
                            }),
                        }}
                    />
                </div>
                <CloseIcon onClick={closeActiveMessage} className="reply-close" />
            </div>
        );
    } else {
        return <></>;
    }
};

export default ReplyMessage;
